import React, { Component } from 'react';
import { appName } from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Helmet } from "react-helmet";
import { Row, Col, Table, Modal } from 'react-bootstrap';
import Roles from '../../../utils/Roles';
import swal from 'sweetalert';
import Pagination from "react-js-pagination";

import PageTitle from '../../../containers/PageTitle';
import Add from './Add';
import Edit from './Edit';
import Select from 'react-select';

class SpecialTraining extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			loginText: 'LOGIN',
			isRedirect: false,
			showAddModal: false,
			showEditModal: false,
			currentPage: 1,
			todosPerPage: 10,
			activePage: 1,
			dataList: [],
			dataView: [],
			editData: [],
			deptList: [],
			categories: [],
		}

		this.handleSearch = this.handleSearch.bind(this);
		this.loadData = this.loadData.bind(this);
		this.onhandleChange = this.onhandleChange.bind(this);
		this.onhandleCandidate = this.onhandleCandidate.bind(this);
	}

	componentDidMount() {

		this.loadData();
		this.loadDepartments();
		this.loadspCategory();
	}

	loadDepartments() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('postcategory/getactivecategories/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ deptList: res['data'].data });
				this.setState({ showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	loadspCategory() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('school/getspecialtrList/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ categories: res['data'].data, showLoader: false });
			}
			else {
				this.setState({ showLoader: false });
			}
		});
	}

	onhandleChange(e) {
		//this.state.dept = e.target.value;
		this.setState({ [e.target.name]: e.target.value });
		this.loadEmployees();
	}

	onhandleCandidate(e) {
		this.state.candidate = e.value;
		var dat = [];
		for (var i = 0; i < this.state.dataList.length; i++) {
			if (this.state.dataList[i].id == this.state.candidate) {
				dat.push(this.state.dataList[i]);
			}
		}
		this.setState({ renewData: dat });
	}

	getOptions() {
		var data = this.state.dataList;
		var rv = [];
		if (Object.keys(data).length > 0) {
			for (var i = 0; i < Object.keys(data).length; i++) {
				var label = data[i].name /*+ ' (' + data[i].subjectname + ')'*/;
				rv.push({ "value": data[i].id, "label": label });
			}
		}
		return rv;
	}

	loadEmployees() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('employee/getEmployeeListBydept/' + this.state.dept + '/' + this.state.companyId + '/' + this.state.masterId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ dataList: res['data'].data, showLoader: false });
				if (this.state.candidate != '') {
					var dat = [];
					for (var i = 0; i < this.state.dataList.length; i++) {
						if (this.state.dataList[i].id == this.state.candidate) {
							dat.push(this.state.dataList[i]);
						}
					}
					this.setState({ renewData: dat });
				}
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}


	loadData() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('school/getspecialtrlist/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ dataList: res['data'].data, dataView: res['data'].data, showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	handleSearch(e) {
		try {
			var list = this.state.dataList;
			var v = e.target.value.toUpperCase();
			var l = list.filter(function (obj) {
				const uname = obj.universityname.toUpperCase();
				const city = obj.city.toUpperCase();
				const country = obj.country.toUpperCase();
				const state = obj.state.toUpperCase();
				const mobile = obj.mobile.toUpperCase();
				return ((uname.indexOf(v) > -1) || (city.indexOf(v) > -1) || (country.indexOf(v) > -1) || (state.indexOf(v) > -1) || (mobile.indexOf(v) > -1));
			});
			this.setState({ dataView: l });
		}
		catch (error) {
			console.log(error);
		}
	}

	handleEdit(id, e) {
		var list = this.state.dataView;
		var index = list.findIndex(function (obj) { return obj.id == id });
		var l = list[index];
		this.setState({ editData: l, showEditModal: true });
	}

	removeValue(id, e) {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('school/removespecialtr/' + this.state.masterId + '/' + this.state.companyId + '/' + id + '/' + token).then(res => {
			if (res['data'].status == '1') {
				var l = this.state.dataList;
				var index = l.findIndex(function (obj) {
					return (obj.id == id);
				});
				l.splice(index, 1);
				this.setState({ dataList: l, dataView: l, showLoader: false });
				notify.show(res['data'].msg, 'success');
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	handleRemoveClick(id, e) {

		swal({ title: 'Confirm', text: 'Do you want to Delete?', buttons: ['No', 'Yes'] }).then((willYes) => {
			if (willYes) this.removeValue(id, e);
		});

	}

	render() {

		const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
		const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
		const currentTodos = this.state.dataView.slice(indexOfFirstTodo, indexOfLastTodo);
		let sno = indexOfFirstTodo + 1;

		return (
			<div>

				<Helmet>
					<title>{appName} | Special Training</title>
				</Helmet>

				<PageTitle title="Special Training" loading={this.state.showLoader} >
					<div className="text-right">
						{Roles.Can('settings', 'specialtraining', 'canadd') ?
							<button className="btn btn-info btn-sm" onClick={() => { this.setState({ showAddModal: true }) }} >
								<i className="fa fa-plus"></i>  Add Special Training
						</button> : null}

						&nbsp;
						<button className="btn btn-info btn-sm" onClick={this.loadData} >
							<i className="fa fa-refresh"></i>
						</button>
					</div>
				</PageTitle>


				<Row>

					<Col md={12} >
						<Table hover responsive className="list-table" >
							<thead>
								<tr>
									<th width="60" >Sl.No</th>
									<th>Name</th>
									<th width="80" >Manage</th>
								</tr>
							</thead>
							<tbody>
								{
									currentTodos.map((item, key) => {
										return <tr key={key} >
											<td>{sno++}</td>
											<td>{item.name}</td>
											<td align="center" >
												{Roles.Can('settings', 'specialtraining', 'canedit') ?
													<button className="btn btn-sm btn-warning btn-lowpadding" onClick={this.handleEdit.bind(this, item.id)} >
														<i className="fa fa-edit"></i>
													</button> : null}
												&emsp;
										{Roles.Can('settings', 'specialtraining', 'candelete') ?
													<button className="btn btn-sm btn-danger btn-lowpadding" onClick={this.handleRemoveClick.bind(this, item.id)} >
														<i className="fa fa-remove"></i>
													</button> : null}
											</td>
										</tr>;
									})
								}
							</tbody>
						</Table>
					</Col>
				</Row>

				<Row>
					<Col md={1} >
						<select className="form-control input-sm" onChange={(e) => { this.setState({ activePage: 1, currentPage: Number(1), todosPerPage: e.target.value }) }} >
							<option value="10"> 10 </option>
							<option value="15"> 15 </option>
							<option value="20"> 20 </option>
							<option value="50"> 50 </option>
							<option value="100"> 100 </option>
						</select>
					</Col>
					<Col md={10} >
						<Pagination
							activePage={this.state.activePage}
							itemsCountPerPage={this.state.todosPerPage}
							totalItemsCount={(this.state.dataView).length}
							pageRangeDisplayed={7}
							onChange={(pN) => { this.setState({ activePage: pN, currentPage: Number(pN) }) }}
						/>
					</Col>
				</Row><br /><br />
				<Row style={{ marginBottom: 5 }} >
					<Col md={3} >
						<label>Select Category</label>
						<select name="dept" className="form-control" onChange={this.onhandleChange.bind(this)}>
							<option value="">--Select--</option>
							{this.state.deptList.map((item, i) =>
								<option value={item.id} >{item.categoryname}</option>
							)}
						</select>
					</Col>
					<Col md={3} >
						<label>Employee List</label>
						<Select name="candidate" defaultValue={null} options={this.getOptions()} onChange={this.onhandleCandidate} />
					</Col>
					<Col md={3}>
						<label>Special Training Year</label>
						<div className="form-group" >
							<input type="month" name="i__splyear" id="i__splyear" onChange={this.onhandleChange.bind(this)} className="form-control" placeholder="training year" />
						</div>
					</Col>
					<Col md={4}>
						<label>Special Training Category</label>
						<div className="form-group" >
							<select name="i__spcategory" id="i__spcategory" className="form-control" onChange={this.onhandleChange.bind(this)} >
								<option value="">Category</option>
								{this.state.categories.map((item, i) => {
									return (
										<option value={item.id}>{item.name}</option>
									);
								})}
							</select>
						</div>
					</Col>
				</Row><br />

				<Modal size="md" show={this.state.showAddModal} onHide={() => { this.setState({ showAddModal: false }) }} className="right" >
					<Modal.Header closeButton >
						<Modal.Title>Add SpecialTraining</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Add afterFinish={this.loadData} />
					</Modal.Body>
				</Modal>

				<Modal size="md" show={this.state.showEditModal} onHide={() => { this.setState({ showEditModal: false }) }} className="right" >
					<Modal.Header closeButton >
						<Modal.Title>Edit SpecialTraining</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Edit editData={this.state.editData} afterFinish={this.loadData} />
					</Modal.Body>
				</Modal>

			</div>
		);
	}

}
export default SpecialTraining;